import { useContext } from 'react';
import { AppModal, IconButton } from '../';
import { AppContext } from '../../providers/AppContext';
import { theme } from '../../theme';
import {
  StyledEarningsModal,
  EarningsControls,
  EarningsListWrapper,
  EarningRow,
  EarningImageWrapper,
  EarningItemRarity,
  EarningItemName,
  EarningMainSection,
  EarningDescription,
  EarningItemImageBg,
  EarningItemImageBgGrid
} from '../EarningsModal/EarningsModal.styled';
import {
  SyncList,
  SyncSectionData,
  SyncSection
} from './SyncModal.styled';
import {
  PopupHeaderStart,
  PopupHeaderEnd,
  PopupHeaderTitle,
  PopupHeader
} from '../PopupHeader/PopupHeader.styled';
import { getBackgroundFromItem } from '../../utils';
import {
  CornerLT,
  CornerLB,
  CornerRT,
  CornerRB,
} from '../UnityPlayer/UnityPlayer.styled';

const SyncTitle = ({ children, background = null }) => {
  return (
    <PopupHeader>
      <PopupHeaderStart $background={background}/>
      <PopupHeaderTitle $background={background}>
        {children}
      </PopupHeaderTitle>
      <PopupHeaderEnd $background={background}/>
    </PopupHeader>
  );
};

const EarningItem = ({ asset }) => {
  const background = getBackgroundFromItem(asset);
  return (
    <EarningRow>
      <EarningImageWrapper $border={true}>
        <EarningItemImageBg style={{ background }}/>
        <EarningItemImageBgGrid src='/assets/item_bg.png' style={{ background }}/>
        <img src={asset.getImgSource()} style={{ position: 'absolute', height: '100%', width: '100%', objectFit: 'cover'}}/>
        <CornerLT/>
        <CornerRT/>
        <CornerLB/>
        <CornerRB/>
      </EarningImageWrapper>
      <EarningMainSection><EarningItemRarity>{asset.getRarity()}</EarningItemRarity></EarningMainSection>
      <EarningDescription><EarningItemName>{asset.getName()}</EarningItemName></EarningDescription>
    </EarningRow>
  );
};

const EarningAvatar = ({ avatar }) => {
  return (
    <EarningRow>
      <EarningImageWrapper $border={true}>
        <img src={avatar.getAvatarImgSource()} style={{ position: 'absolute', height: '100%', width: '100%', objectFit: 'cover'}}/>
        <CornerLT/>
        <CornerRT/>
        <CornerLB/>
        <CornerRB/>
      </EarningImageWrapper>
      <EarningMainSection><EarningItemRarity>{avatar.getTokenId()}</EarningItemRarity></EarningMainSection>
      <EarningDescription><EarningItemName>{avatar.getName()}</EarningItemName></EarningDescription>
    </EarningRow>
  );
};

const SyncResultsSection = ({ addedItems = [], removedItems = [], addedAvatars = [], removedAvatars = [] }) => {
  const addAlpha = (colorCode) => {
    return colorCode + 'AA';
  };
  return (
    <EarningsListWrapper>
      <SyncList>
        {addedAvatars.length > 0 &&
          <SyncSection $background={addAlpha(theme.baseGreen)}>
            <SyncTitle background={theme.baseGreen}>Added Avatars:</SyncTitle>
            <SyncSectionData>
              {addedAvatars.map(a => (<EarningAvatar avatar={a}/>))}
            </SyncSectionData>
          </SyncSection>
	}
        {addedItems.length > 0 &&
          <SyncSection $background={addAlpha(theme.baseGreen)}>
            <SyncTitle background={theme.baseGreen}>Added Items:</SyncTitle>
            <SyncSectionData>
              {addedItems.map(it => (<EarningItem asset={it}/>))}
            </SyncSectionData>
          </SyncSection>
	}
        {removedAvatars.length > 0 &&
          <SyncSection $background={addAlpha(theme.baseRed)}>
            <SyncTitle background={theme.baseRed}>Removed Avatars:</SyncTitle>
            <SyncSectionData>
              {removedAvatars.map(a => (<EarningAvatar avatar={a}/>))}
            </SyncSectionData>
          </SyncSection>
	}
        {removedItems.length > 0 &&
          <SyncSection $background={addAlpha(theme.baseRed)}>
            <SyncTitle background={theme.baseRed}>Removed Items:</SyncTitle>
            <SyncSectionData>
              {removedItems.map(it => (<EarningItem asset={it}/>))}
            </SyncSectionData>
          </SyncSection>
	}
      </SyncList>
    </EarningsListWrapper>
  );
};

const SyncModal = ({ syncResults: { addedItems = [], removedItems = [], addedAvatars = [], removedAvatars = [] } }) => {
  const title = 'Wallet Synchronized!';
  const { setSyncResults, setErrorData } = useContext(AppContext);

  const onClose = () => {
    setErrorData(null);
    setSyncResults(null);
  }
  return (
    <AppModal>
      <StyledEarningsModal>
        <SyncTitle>{title}</SyncTitle>
        <SyncResultsSection addedItems={addedItems} removedItems={removedItems} addedAvatars={addedAvatars} removedAvatars={removedAvatars}/>
        <EarningsControls>
          <IconButton onClick={onClose}>
            OK
          </IconButton>
        </EarningsControls>
      </StyledEarningsModal>
    </AppModal>
  );
};

export default SyncModal;
